import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import App from "@/App.vue"
    import { provideAuth0 } from "@/Services/Auth0/auth0-plugin";
    /* eslint-disable */
    
export default /*#__PURE__*/_defineComponent({
  __name: 'Shell',
  setup(__props) {

    provideAuth0();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(App))
}
}

})